function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
var ace = window.ace;
var AdvancedDanmakuJsonEditor = function () {
    function AdvancedDanmakuJsonEditor(player, el) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, AdvancedDanmakuJsonEditor);
        this.player = player;
        this.el = el;
        this.template = this.player.template;
        this.editor = null;
        this.init();
    }
    _createClass(AdvancedDanmakuJsonEditor, [
        {
            key: 'init',
            value: function init() {
                var _this = this;
                var $ = this.el.querySelector.bind(this.el);
                this.template.ade_json_prebox = $('.mfunsPlayer-ade-prebox');
                this.template.ade_json_clear = $('.mfunsPlayer-ade-clear');
                this.template.ade_json_preview = $('.mfunsPlayer-ade-preview');
                this.template.ade_json_emit = $('.mfunsPlayer-ade-emit');
                this.template.ade_json_copy = $('.mfunsPlayer-ade-copy');
                this.template.ade_json_copysuccess = $('.mfunsPlayer-ade-copysuccess');
                this.template.ade_json_clear.addEventListener('click', function () {
                    _this.clear();
                });
                this.template.ade_json_preview.addEventListener('click', function () {
                    _this.preview();
                });
                this.template.ade_json_emit.addEventListener('click', function () {
                    _this.send();
                });
                this.template.ade_json_copy.addEventListener('click', function () {
                    var _this$editor;
                    navigator.clipboard.writeText(((_this$editor = _this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.getValue()) || '').then(function (res) {
                        _this.template.ade_json_copysuccess.style.display = '';
                        var timer = setTimeout(function () {
                            _this.template.ade_json_copysuccess.style.display = 'none';
                            clearTimeout(timer);
                        }, 3000);
                    });
                });
            }
        },
        {
            key: 'createEditor',
            value: function createEditor() {
                if (ace) {
                    this.editor = ace.edit(this.template.ade_json_prebox);
                    this.editor.session.setOptions({
                        mode: 'ace/mode/json',
                        tabSize: 2
                    });
                    this.editor.setValue('[{"type":"text",}\n]');
                    this.editor.gotoLine(5, 20);
                } else {
                    this.template.ade_json_prebox.innerText = '> 页面未启用ace代码编辑器\uFF0C无法使用代码编辑';
                }
            }
        },
        {
            key: 'preview',
            value: function preview() {
                var _this$editor2, _this2 = this;
                var danmaku = {
                    content: (_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.getValue(),
                    time: 0,
                    id: 'preview-'.concat(Date.now())
                };
                console.log(danmaku.content);
                if (true) {
                    this.player.seek(danmaku.time / 1000);
                }
                window.requestAnimationFrame(function () {
                    _this2.player.advancedDanmaku.engine.playDanmaku(danmaku);
                });
            }
        },
        {
            key: 'send',
            value: function send() {
                var _this$editor3;
                var danmaku = {
                    content: (_this$editor3 = this.editor) === null || _this$editor3 === void 0 ? void 0 : _this$editor3.getValue(),
                    time: 0
                };
                console.log(danmaku.content);
                this.player.advancedDanmaku.engine.addDanmaku(danmaku);
                if (false) {
                    this.player.advancedDanmaku.engine.playDanmaku(danmaku);
                }
            }
        },
        {
            key: 'clear',
            value: function clear() {
                this.editor.setValue('');
            }
        }
    ]);
    return AdvancedDanmakuJsonEditor;
}();
export default AdvancedDanmakuJsonEditor;